import './polyfill';
import 'babel-polyfill';
import React from 'react';
// import { trackPageLoad, trackPageLeave } from '@src/tracker';
import initialize from '@src/initialize';
import * as constants from '@src/constants';
import renderApp from '@src/render-app';

// trackPageLoad();
// trackPageLeave();
/**
 * 禁止浏览器自动帮助恢复滚动位置
 * @type {string}
 */
window.history.scrollRestoration = 'manual';

(async () => {
  if (DEPLOY_ENV !== 'master' && constants.IS_MOCK_ON) {
    await require('@xfe-team/utils/src/intercept-jsonp-with-mocks').default(require('@src/services/zt/mock.json'));
  }

  /**
   * 初始化
   */
  initialize();

  renderApp();
})();

/**
 * 热更新
 */
if (module.hot) {
  module.hot.accept();
}



// WEBPACK FOOTER //
// ./src/index.js